<template>
  <v-dialog v-model="show"
            width="450"
            content-class="modal modal-round">

    <div class="close"
         @click="show = false">&times;</div>

    <v-card>
      <app-released-ips-body @close="show = false"></app-released-ips-body>
    </v-card>
  </v-dialog>
</template>

<script>
    import AppReleasedIpsBody from './components/ReleasedIpsBody'
    import EventBus from '@packages/event-bus'

    export default {
        components: {
            AppReleasedIpsBody
        },

        data() {
            return {
                show: false
            }
        },

        methods: {
            resetReleseadIpsHandler(local) {
                this.show = true
                EventBus.$emit('LOAD_RELESEAD_IPS', local)
            }
        },


        mounted() {
            EventBus.$on('RESET_RELESEAD_IPS', this.resetReleseadIpsHandler)
        },

        beforeDestroy() {
            EventBus.$off('RESET_RELESEAD_IPS', this.resetReleseadIpsHandler)
        },

    }
</script>

<style scoped>
.v-card {
  padding: 10px !important;
}
</style>
